import { SET_COUNTRY, CLEAR_COUNTRY } from '../actions/actionTypes';
import { CountryAction } from '../actions/country';

export type CountryReducer = {
    code: string;
    name: string;
    language: string;
    iso_code: string;
    currency_code: string;
    national_id_length: number;
    ga_infix: string;
    minimum_mobile_length: number;
    maximum_mobile_length: number;
};

export type CountryReducerState = {
    country: CountryReducer;
};

const intialState: CountryReducer = {
    code: '',
    name: '',
    language: '',
    iso_code: '',
    currency_code: '',
    national_id_length: 0,
    ga_infix: '',
    minimum_mobile_length: 0,
    maximum_mobile_length: 0,
};

const country = (state = intialState, action: CountryAction): CountryReducer => {
    switch (action.type) {
        case SET_COUNTRY:
            return {
                ...state,
                ...action.payload,
            };
        case CLEAR_COUNTRY:
            return intialState;
        default:
            return state;
    }
};

export default country;
